import { memo } from "react";
import { Step, StepLabel, Stepper } from "@mui/material";

interface StepsProgressBarProps {
  currentStep: number;
  labels: string[];
}

function StepsProgressBarInner({
  currentStep,
  labels,
}: StepsProgressBarProps) {
  return (
    <div className="mb-4">
      <Stepper activeStep={currentStep} alternativeLabel>
        {labels.map((label) => (
          <Step key={label}>
            <StepLabel>
              <span className="d-none d-sm-inline">{label}</span>
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </div>
  );
}

StepsProgressBarInner.displayName = "StepsProgressBar";

const StepsProgressBar = memo(StepsProgressBarInner);
StepsProgressBar.displayName = "StepsProgressBar";

export default StepsProgressBar;
